import { createSlice } from "@reduxjs/toolkit";

import type { AxiosError, Method } from "axios";

export type ErrorState = {
  message?: string;
  status?: number;
  eventId?: string;
  query?: {
    method: Method;
    url: string;
    endpoint: string;
  };
  data?: Record<string, unknown>;
} & Partial<AxiosError>;

const initialState: ErrorState[] = [];

const errorSlice = createSlice({
  name: "errors",
  initialState,
  reducers: {
    addApiError: (state, action) => {
      state.push(action.payload);
    },
    clearApiErrors: (_state) => {
      return [];
    },
  },
});

export const selectApiErrors = (state: { errors: ErrorState[] }) => state.errors;
export const { addApiError, clearApiErrors } = errorSlice.actions;

export default errorSlice.reducer;
